"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imageRole = exports.iconAlt = exports.checkboxType = exports.classes = void 0;
var classes = {
  checkboxContainer: 'bds-checkbox-container',
  iconContainer: 'bds-checkbox-icon-container',
  iconContainerHover: 'bds-checkbox-icon-container-hover',
  labelContainer: 'bds-label-container',
  checkboxIcon: 'bds-checkbox-icon',
  checkboxIconDisabled: 'bds-checkbox-icon-disabled',
  checkboxIconChecked: 'bds-checkbox-icon-checked',
  checkboxIconReadonly: 'bds-checkbox-icon-readonly',
  checkboxIconCheckedDisabled: 'bds-checkbox-icon-checked-disabled',
  checkboxIconIndeterminate: 'bds-checkbox-icon-indeterminate',
  checkboxIconIndeterminateDisabled: 'bds-checkbox-icon-indeterminate-disabled',
  checkboxIconInnerChecked: 'bds-checkbox-icon-inner-checked',
  checkboxIconInnerReadonly: 'bds-checkbox-icon-inner-readonly',
  checkboxIconInnerIndeterminate: 'bds-checkbox-icon-inner-indeterminate',
  checkboxIconInnerIndeterminateDisabled: 'bds-checkbox-icon-inner-indeterminate-disabled'
};
exports.classes = classes;
var checkboxType = 'checkbox';
exports.checkboxType = checkboxType;
var iconAlt = 'icon';
exports.iconAlt = iconAlt;
var imageRole = 'img';
exports.imageRole = imageRole;